type UniformTableRow = {
	timestamp: Date
	sensorValues: Map<number | string, number>
}

type Datapoint = {
	id: number | string
	value: number
	timestamp: Date
}

export function interpolateDatasets(datasets: { id: number | string; data: [Date, number][] }[]) {
	let datapoints: Datapoint[] = []
	for (const dataset of datasets) {
		datapoints = datapoints.concat(
			dataset.data.map((datapoint) => {
				return {
					id: dataset.id,
					timestamp: datapoint[0],
					value: datapoint[1],
				}
			})
		)
	}

	const uniformTable: UniformTableRow[] = []

	// Group data by timestamp
	const dataGroupedByTimestamp = new Map<number, Datapoint[]>()
	for (const datapoint of datapoints) {
		const key = datapoint.timestamp.getTime()
		let timestampDatapoints = dataGroupedByTimestamp.get(key)
		if (timestampDatapoints === undefined) {
			timestampDatapoints = []
			dataGroupedByTimestamp.set(key, timestampDatapoints)
		}
		timestampDatapoints.push(datapoint)
	}

	const sensorStateBySensorId = new Map<number | string, number>()

	// Run through the timestamps chronologically
	const timestampsSorted = Array.from(dataGroupedByTimestamp.keys()).sort()
	for (const timestampMs of timestampsSorted) {
		const datapointsForTimestamp = dataGroupedByTimestamp.get(timestampMs) ?? []
		// Set the state of each sensor
		for (const datapoint of datapointsForTimestamp) {
			sensorStateBySensorId.set(datapoint.id, datapoint.value)
		}
		// Create and save the row
		const row: UniformTableRow = {
			timestamp: new Date(timestampMs),
			sensorValues: new Map(),
		}
		// For each sensor, there will be either a new value or a value that was previously set
		for (const [sensorId, sensorValue] of sensorStateBySensorId) {
			row.sensorValues.set(sensorId, sensorValue)
		}
		uniformTable.push(row)
	}
	uniformTable.sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime())

	const uniformDatasets = datasets.map((dataset) => {
		return {
			sensorId: dataset.id,
			dataPoints: uniformTable.map((entry) => {
				return {
					timestamp: entry.timestamp,
					value: entry.sensorValues.get(dataset.id) ?? null,
				}
			}),
		}
	})

	return uniformDatasets
}
